import { createContext, PropsWithChildren } from "react";
import { useAuth } from "../hooks/useAuth";

export const AuthContext = createContext<ReturnType<typeof useAuth>>({ login: () => Promise.reject(), register: () => Promise.reject(), check: () => Promise.reject(), logout: () => void 0, reset2FA: () => Promise.reject(), user: null });

export const AuthProvider = (props: PropsWithChildren) => <AuthContext.Provider value={useAuth()} {...props} />;
